import { type TranslationTree } from '@/i18n/types';

export const messages = {
  title: 'Comissões',
  toReceive: 'A receber',
  paid: 'Pago',
  hint: 'Soma desde o início, não só do período. A equipe Bodyprint confirma cada comissão antes do pagamento.',
} satisfies TranslationTree;
